import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import axios from 'axios';
import React, { useState } from 'react'
import { Button, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import default_image_url from '../../../../redux/api/API';
import MainLoading from '../../../../utils/MainLoading';
import { fetchUserProfile } from '../../../../redux/action/userProfile/user-profile'
import { useTranslation } from 'react-i18next';

const Cover = () => {
    const [forceUpdate, setForceUpdate] = useState(0)
    const [photo, setPhoto] = useState('')
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [selectedImage, setSelectedImage] = useState();
    const [progerssbar, setProgressbar] = useState(0)
    const [deleteImage, setDeleteImage] = useState(false)
    const dispatch = useDispatch()
    const user_profile = useSelector(state => state.user_profile)
    let userdata = JSON.parse(localStorage.getItem("user"))
    const {t} = useTranslation();

    const handleClose = () => { 
        setDeleteImage(false) 
    }

    const handleDelete = (id) => {
        setDeleteImage(true)
    }

    const deleteThisImage = () => {
        axios.delete(`co/profile/cover`)
          .then (res => {
            if(res.data) {
                if(res.data.success === true) {
                    toast.dismiss()
                    toast.success(t("toast_successfully_removed") , {position: 'bottom-right',className: 'foo-bar'}) 
                    dispatch(fetchUserProfile(userdata.id))
                    setDeleteImage(false) 
                }
            }
          })
          .catch(err => console.log(err))
    }

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    };

    const handleUploadImage = (e) => {
        e.preventDefault()
        setProgressbar(true)

        const formData = new FormData();
        formData.append('image',photo)

        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const {loaded, total} = progressEvent;
                let percent = Math.floor( (loaded * 100) / total )
                if( percent < 100 ){
                    setUploadPercentage(percent)
                }
            }
        }
        axios.post('co/profile/cover', formData, config)
        .then(res => {
            setUploadPercentage(100)
            setTimeout(() => {
                setUploadPercentage(0)
            }, 1000);
            setForceUpdate(1)
            toast.dismiss()
            toast.success(t("toast_successfully_done") , {position: 'bottom-right',className: 'foo-bar'})
            setPhoto()
            setSelectedImage()
            setProgressbar()
            dispatch(fetchUserProfile(userdata.id))
        })
        .catch(err => {
            console.log(err)
            if(err.response.status === 403) {
                setPhoto()
                setSelectedImage()
                setProgressbar()
                toast.dismiss()
                toast.error(t("toast The maximum accepted image size is 2 MB") , {position: 'bottom-right',className: 'foo-bar'})
            } else if(err.response.status === 500) {
                setPhoto()
                setSelectedImage()
                setProgressbar()
                toast.dismiss()
                toast.error(t("toast_content_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
            } else {
                setPhoto()
                setSelectedImage()
                setProgressbar()
                toast.dismiss()
                toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
            }
        })
    }

  return (
    <div className='mt-5'>
        <p>{t("The maximum accepted image size is 2 MB")}</p>
        <p>{t("The_selected_image_format_must_be_one_of_the_following_jpeg_png_jpg_gif_svg")}</p>
        <Row className='single_gallery_images pb-5'>
            {user_profile.loading ? 
                <MainLoading />
            :
            user_profile.user && 
                user_profile.user.cover ?
                    <div className='col-lg-3 single_gallery_image' >
                        <img src={default_image_url+user_profile.user.cover} alt="gallery" />
                        <button className='img_delete_btn' onClick={handleDelete}> {t("delete")} </button>
                    </div>
                :
                    ''
            }

            {progerssbar ? 
                    <div className='col-lg-2 selectImage'>
                        {selectedImage && (
                            <div className='selectedImage'>
                                <img
                                src={URL.createObjectURL(selectedImage)}
                                alt="Thumb"
                                />
                            </div>
                        )}
                        {uploadPercentage > 0 && <ProgressBar className='mt-3' style={{width: '90%',border: '1px solid #000',margin: '.2rem'}} now={uploadPercentage} active="true" label={`${uploadPercentage}%`} />}
                    </div>
                :
                    <div className='col-lg-3 selectImage'>
                        {selectedImage && (
                            <div className='selectedImage'>
                                <img
                                src={URL.createObjectURL(selectedImage)}
                                alt="Thumb"
                                />
                                <button onClick={removeSelectedImage} className='remove_selected_image'>
                                <i className='fa fa-times'></i>
                                </button>
                            </div>
                        )}
                            {photo ? 
                                <>
                                    <div className='gallery_container'>
                                        <Form className='submitForm' onSubmit={handleUploadImage}>
                                            <button className='btn btn-success btn-sm px-4'>{t("send")}</button>
                                        </Form>
                                    </div>
                                </>
                            :
                                <Form className='chooseForm' onSubmit={handleUploadImage}>
                                    <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                                    <i className='fa fa-plus'></i>
                                    <span>{t("choose picture")}</span>
                                </Form>
                            }
                    </div>
                }
                {deleteImage ? 
                    <Modal show={deleteImage} onHide={handleClose}>
                        <Modal.Header>
                            <Modal.Title>{t("delete this item")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                {t("Cancel")}
                            </Button>
                            <Button variant="danger" onClick={deleteThisImage}>
                                {t("confirm")}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                : ''}
        </Row>
    </div>
  )
}

export default Cover;
